__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/ec2124870b607aa5ca4c30b0615e6732cb1de233639a8cf979dfd30d/";